import { render, staticRenderFns } from "./TemplateAddForm.vue?vue&type=template&id=265cee3f&scoped=true"
import script from "./TemplateAddForm.vue?vue&type=script&lang=js"
export * from "./TemplateAddForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateAddForm.vue?vue&type=style&index=0&id=265cee3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265cee3f",
  null
  
)

export default component.exports